import React__default from 'react';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';

var AdvancedTableHiddenDescription = function AdvancedTableHiddenDescription(_ref) {
  var id = _ref.id,
    messageKey = _ref.messageKey;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.hiddenDescription,
    id: id
  }, translate(messageKey));
};

export { AdvancedTableHiddenDescription as default };
